<template>
	<UserRegistrationFullScreenLayout>
		<div class="title-text">To make the most of Ply, you need a Chrome browser.</div>
		<div class="description-text mt-1 display-flex flex-row">
			Open Ply from Chrome (You can download chrome
			<a target="_blank" :href="DOWNLOAD_CHROME_LINK" class="ml-1 link-text">here</a>
			)
		</div>
		<v-img class="chrome-image mt-6" :src="DownloadChromeImage" />
		<div class="mt-4">Or</div>
		<router-link to="/">
			<div class="continue-with-current-browser-text">continue with {{ browserName }}</div>
		</router-link>
		<v-btn style="height: 47px" class="mt-4" color="primary pr-8" target="_blank" :href="DOWNLOAD_CHROME_LINK">
			<SIcon name="chrome" class="mr-6 mt-1" />
			Download Chrome
		</v-btn>
	</UserRegistrationFullScreenLayout>
</template>

<script>
const DOWNLOAD_CHROME_LINK = 'https://www.google.com/chrome/';
import DownloadChromeImage from '@/assets/png/icon-download-chrome.png';
import UserAgentService from '@/utils/user-agent-service';
import UserRegistrationFullScreenLayout from '@/views/userRegistration/UserRegistrationFullScreenLayout.vue';
import UserRegistrationMixin from '@/views/userRegistration/helpers/UserRegistrationMixin.js';
export default {
	name: 'InstallChrome',
	components: {
		UserRegistrationFullScreenLayout,
	},
	mixins: [UserRegistrationMixin],
	computed: {
		browserName() {
			return UserAgentService.getBrowserName();
		},
	},
	data: () => ({
		DownloadChromeImage,
		DOWNLOAD_CHROME_LINK,
	}),
};
</script>

<style scoped lang="scss">
.title-text {
	font-size: 20px;
	font-weight: bold;
	text-align: center;
	color: var(--primary-font-color);
}
.description-text {
	font-size: 16px;
	font-weight: bold;
	text-align: center;
	color: var(--primary-font-color);
}
.link-text {
	font-size: 16px;
	cursor: pointer;
	font-weight: bold;
	text-decoration: underline;
	color: var(--primary-color);
}
.chrome-image {
	max-width: 716px;
	max-height: 440px;
}
.continue-with-current-browser-text {
	font-size: 16px;
	cursor: pointer;
	text-align: center;
	font-weight: normal;
	text-decoration: underline;
	color: var(--primary-color);
}
</style>
